<script lang="ts">
	import { SystemScreenBreakpoints } from '@Shelly/shelly-design-system/helpers/enums';

	/** The expiry text to display, e.g. "Expires in 14 days" */
	export let text: string;

	let windowClientWidth: number;

	$: isTablet = windowClientWidth <= SystemScreenBreakpoints.TABLET_MAX;
</script>

<svelte:window bind:innerWidth={windowClientWidth} />

<div class={`promo-expiry-tag ${isTablet ? 'darker' : ''}`} aria-hidden="true">
	<span class="promo-expiry-tag__text">{text}</span>
</div>

<style>
	.promo-expiry-tag {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		align-self: flex-start;
		padding: 4px 8px;
		background: var(--color-base, #151617);
		border-radius: 40px;
	}

	.promo-expiry-tag.darker {
		background: black;
	}

	.promo-expiry-tag__text {
		font-size: 10px;
		font-weight: 500;
		letter-spacing: 0.6px;
		line-height: normal;
		text-transform: uppercase;
		color: var(--color-white, #ffffff);
		white-space: nowrap;
	}
</style>
